<template>
    <fragment>
        <ImageTemplateIndex/>
        <ImageTemplateAdmin/>
        <ImageTemplateSettings/>
        <ImageTemplateWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import ImageTemplateWooCommerce from "./__partials__/ImageTemplateWooCommerce";
    import ImageTemplateSettings from "./__partials__/ImageTemplateSettings";
    import ImageTemplateIndex from "./__partials__/ImageTemplateIndex";
    import ImageTemplateAdmin from "./__partials__/ImageTemplateAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            ImageTemplateAdmin,
            ImageTemplateIndex,
            ImageTemplateSettings,
            ImageTemplateWooCommerce
        }
    }
</script>

<style scoped>

</style>